import { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import SiteFooter from "../components/SiteFooter";
import "./professional.css";

function Landing() {
  useEffect(() => {
    document.title = "Jérôme Lecoq | Neuroscientist and open science builder";
  }, []);

  return (
    <main className="ProfessionalPage">
      <section className="ProfessionalHero">
        <div className="ProfessionalHeroCopy">
          <h1>Jérôme Lecoq</h1>
          <p className="ProfessionalThesis">I build observatories and share them to understand the brain.</p>
          <p className="ProfessionalIntro">
            I am an Associate Investigator at the Allen Institute. With a 
            quantitative background in physics and engineering, I co-developed 
            and openly share high-throughput instrumentation platforms for studying 
            neural computation. Together with the scientific community,
            I aim to understand how we learn.
          </p>
          <div className="ProfessionalActions">
            <Link className="ProfessionalPrimaryAction" to="/projects">
              Explore the work <FiArrowRight aria-hidden="true" />
            </Link>
            <Link className="ProfessionalTextAction" to="/blog">
              Read the blog
            </Link>
          </div>
        </div>

        <figure className="ProfessionalPortrait">
          <img src="/jerome-lecoq.jpg" alt="Jérôme Lecoq" />
          <figcaption>
            <span>Associate Investigator</span>
            Allen Institute
          </figcaption>
        </figure>
      </section>

      <section className="ProfessionalWork" aria-label="Current work">
        <div className="ProfessionalWorkItems">
          <article>
            <h3>OpenScope</h3>
            <p>
              With <a href="https://alleninstitute.org/person/christof-koch/" target="_blank" rel="noreferrer">Christof Koch</a>, I established OpenScope and secured its funding. 
              I lead the daily execution of community-proposed brain observatory
              experiments on high-throughput, standardized neurophysiology platforms. 
              All our collected data are openly shared.
            </p>
            <Link to="/projects#openscope">How it works <FiArrowRight aria-hidden="true" /></Link>
          </article>
          <article>
            <h3>Understanding the brain</h3>
            <p>
              Research combining large-scale neurophysiology, quantitative modeling, 
              and AI to study sensory inference, reliable population codes, 
              and communication between brain areas.
            </p>
            <Link to="/projects#understanding-the-brain">Explore the science <FiArrowRight aria-hidden="true" /></Link>
          </article>
          <article>
            <h3>Flow of ideas</h3>
            <p>
              A parallel line of work spanning open blogging with SmallChains,
              multidimensional scientific authorship, and independently citable evidence.
            </p>
            <Link to="/projects#flow-of-ideas">Explore the work <FiArrowRight aria-hidden="true" /></Link>
          </article>
        </div>
      </section>

      <section className="ProfessionalNotebook" aria-labelledby="blog-heading">
        <div>
          <h2 id="blog-heading">Blog</h2>
        </div>
        <div>
          <p>
            Short posts on neuroscience, technology, books, and
            whatever comes to my mind. The posts are powered by unique, wallet-authenticated, on-chain publishing. 
          </p>
          <Link to="/blog">Browse the blog <FiArrowRight aria-hidden="true" /></Link>
        </div>
      </section>

      <SiteFooter />
    </main>
  );
}

export default Landing;